import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-give',
  templateUrl: './give.component.html',
  styleUrls: ['./give.component.css']
})
export class GiveComponent implements OnInit, OnDestroy {
  testimonyReadMore = false;
  testimonyReadMore1 = false;
  testimonyText = 'Show more';
  testimonyText1 = 'Show more';
  title = 'Daystar Christian Centre - raising role models. | Give';


  constructor(private titleService: Title,
    private metaService: Meta,
    private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'landing-page');
    this.renderer.addClass(document.body, 'sidebar-collapse');
    this.loadScripts();
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'keywords', content: 'daystar, daystarng, rolemodel, rolemodels, leaders, leadership, give' },
      { name: 'description', content: 'We appreciate all givers very much because your gifts contribute substantially to the work of God in reaching the needy. May bountiful blessings abound to you, in Jesus’ name, amen.' },
      { name: 'robots', content: 'index, follow' }
    ]);
  }

  toggleAcoutReadMore() {
    this.testimonyReadMore = !this.testimonyReadMore;
    this.testimonyText = this.testimonyText ? 'Show less' : 'Show more';
  }

  toggleAcoutReadMore1() {
    this.testimonyReadMore1 = !this.testimonyReadMore1;
    this.testimonyText1 = this.testimonyText1 ? 'Show less' : 'Show more';
  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/core/jquery.min.js',
      'assets/js/core/popper.min.js',
      'assets/js/core/bootstrap.min.js',
      'assets/js/plugins/bootstrap-switch.js',
      'assets/js/plugins/nouislider.min.js',
      'assets/js/plugins/bootstrap-datepicker.js',
      'assets/js/now-ui-kit.js?v=1.2.0',
      'assets/js/main.js',
      // 'assets/js/jquery.fancybox.min.js'
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'landing-page');
    this.renderer.removeClass(document.body, 'sidebar-collapse');
  }
}
